import { Reveal, Overline } from "./anim";

export default function ExperienceStatement() {
  return (
    <section className="relative bg-ink py-24 md:py-40 border-t border-line-d grain" data-testid="experience-statement">
      <div className="mx-auto max-w-[1100px] px-6 md:px-10">
        <Reveal>
          <Overline>Not a presentation. An experience.</Overline>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-10 font-display font-light text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-sand leading-[1.12] tracking-tight">
            This isn't another presentation about leadership, trust and connection.
            This is an <span className="italic text-terra">experience</span>.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-10 max-w-2xl text-muted-d text-lg md:text-xl leading-relaxed">
            The goal isn't to remove professionalism. It's to discover what becomes possible when professionalism and
            humanity can co-exist.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
